import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  AppInitializeAction,
  FleetApiActions,
  SetSystemDatesAction,
  SetVariablesDataAction,
} from '../actions';
import {
  catchError,
  debounceTime,
  EMPTY,
  mergeMap,
  of,
  switchMap,
  withLatestFrom,
} from 'rxjs';
import { Store } from '@ngrx/store';
import { StoreInitService } from '@dashboard/dashboard-library/helpers/store-init.service';
import { ToDateSelector } from '../selectors';
import { IsLatestAvailableMinute } from '@core/constants/time.defaults';
import { DebounceHackMs } from '@dashboard/dashboard-store/effects/api-debounce-hack';

@Injectable()
export class FleetEffects {
  constructor(
    private actions$: Actions,
    private _store: Store,
    private _storeInitHelper: StoreInitService
  ) {}

  trigerLoadFleetData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppInitializeAction, SetSystemDatesAction),

      mergeMap((action) => {
        const isDateAction = action.type === SetSystemDatesAction.type;

        if (isDateAction && !action.toDate) return EMPTY;

        return of(FleetApiActions.call());
      })
    )
  );

  //Every time someone changes the date we need to update the fleet data.
  loadFleetData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FleetApiActions.call),
      debounceTime(DebounceHackMs),
      withLatestFrom(this._store.select(ToDateSelector)),
      switchMap(([, activeDate]) => {
        console.log('Fleet api date', activeDate);
        return this._storeInitHelper.getInitialVesselsData(
          IsLatestAvailableMinute(activeDate) ? 'latest' : activeDate
        );
      }),
      switchMap((variableMeta) =>
        of(
          SetVariablesDataAction({ variableMeta, source: 'API' }),
          FleetApiActions.success()
        )
      ),
      catchError(() => of(FleetApiActions.failure()))
    )
  );
}
